import useMutationCall from "../../../hooks/useMutationCall";
import { useAddSkillToEmployeeMutation } from "../employeesSlice";

const useAddSkillToEmployee = () => {
  return useMutationCall(useAddSkillToEmployeeMutation);
};

export default useAddSkillToEmployee;
